const global = {

        //devlopment side url
        serverUrl: "http://54.193.130.43:8000",
        stripe_p_key: 'pk_test_51LixZiJTvBqbiOKnPcS69thhnqhwWqXz4RZteSKyoBjG1CytGinFMveOjGlNUqE7F9AZYpJRasUy1uwhxSrpZvoO008CcnCRNR'

        //Client side url
        
        // serverUrl: "http://3.101.154.87:8000/"

  };
  
  export default global;